import { Component, Input } from '@angular/core';

@Component({
  selector: 'iv-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.scss']
})
export class CheckboxListComponent {
  @Input()
  onFeeSplit = false;

  @Input()
  label: string;

  @Input()
  subLabel: string;

  constructor() { }

}
